var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right inverted--text mt-2 mr-2 font-very-small slightly-transparent"},[_vm._v("\n  "+_vm._s(_vm.usageEventsDisabled === true ? "Events Disabled " : "")+"\n  "+_vm._s(_vm.version)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }